import React from 'react';

const PromptScript: React.FC = () => {
  return (
    <div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <details className="govuk-details">
          <summary className="govuk-details__summary">
            <span className="govuk-details__summary-text">Prompt Script</span>
          </summary>
          <div className="govuk-details__text">
            <div className="govuk-body">
              I will press a ‘Record’ button after asking each question. At the
              end of each response I will press stop. You can ask me anything
              when responding and we will simply delete any text that is not
              relevant from the transcript at the end.
            </div>
            <h3 className="govuk-heading-s">
              Recommendation for the professional
            </h3>
            <div className="govuk-body">
              <ul className="govuk-list govuk-list--bullet">
                <li>
                  Are you in place with a strong enough internet connection?
                </li>
                <li>Is there a way to reduce background noise?</li>
                <li>
                  If the transcription is not working correctly, please type in
                  the person’s wishes.
                </li>
              </ul>
            </div>
          </div>
        </details>
      </div>
    </div>
  );
};

export default PromptScript;
